import * as core from '../../../../../../../core'

import { query } from './degree-of-change-by-workstream.query'

export const RESOURCE = {
  payload: {
    alias: 'degree.of.change.by.workstream',
    description: 'Chart view of degree of change by workstream',
    name: 'Degree of Change by Workstream',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
